/// <amd-module name="Test/Analytics/Common/Utils/StringFormattingUtility" />

import * as Resources from "Test/Analytics/Common/Resources";
import { format } from "VSS/Core/Util/String";

export class StringFormattingUtility {
    public static getDeletedEnvironmentDefIdDisplayString(envId: string): string {
        return format(Resources.DeletedStageIdDisplayText, envId);
    }

    public static getFormattedValueStringForODataQuery(value: string): string {
        if (!value) {
            return value;
        }

        let formattedString: string = value;

        // Convert single quotes to double quotes
        formattedString = value.replace(/'/g, "''");

        return formattedString;
    }
}

/**
 * Converts the specified value to a display string.
 *
 * @param value The value to convert.
 * @param format The value to convert.
 */
export function convertValueToDisplayString(value: any, format?: string): string {
    if (value !== null && typeof value !== "undefined") {
        if (typeof value === "string") {
            return value;
        } else if (value instanceof Date) {
            if (format) {
                return value.toLocaleString(format);
            }
            return value.toLocaleString();
        } else if (typeof value === "number") {
            if (format) {
                return new Date(value).toLocaleString(format);
            } else {
                return value.toLocaleString();
            }
        } else if (typeof value === "boolean") {
            return value ? "True" : "False";
        } else {
            return value.toString();
        }
    }

    return "";
}
